export default "__VITE_ASSET__nbfU3VT5__";